export default {
  labelWidth: 80,
  labelAlign: 'left',
  itemHeight: 32,
}
